import type { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { MenuCategoryPartnerOptionsQuerySchema } from '~/services/api/generated'

// Mirrors MenuCategoryOptionsRequest rules.
export const MenuCategoryPartnerOptions = (
  _context: NoContext
): z.ZodType<z.output<typeof MenuCategoryPartnerOptionsQuerySchema>> =>
  MenuCategoryPartnerOptionsQuerySchema
